import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../containers/checkoutPage/CheckoutPage.m.sass';
import CartProduct from '../cartProduct/CartProduct';


export default class CheckoutCartSummary extends React.PureComponent {
  render() {
    const {items, subtotal, total} = this.props;

    return (
      <div className={styles.checkout_cart}>
        <div className={styles.cart}>
          <div className={styles.cart_top}>
            <div className={styles.cart_header}>Product</div>
            <div className={styles.cart_header}>Total</div>
          </div>

          <div className={styles.cart_inner}>
            {items.map(item => (
              <CartProduct
                key={item.id}
                name={CartProduct.getItemTitle(item)}
                price={item.total}
              />
            ))}
          </div>

          <div className={styles.cart_summary}>
            <div className={styles.cart_summaryInner}>
              <CartProduct
                name="Cart Subtotal"
                price={subtotal}
              />
              <CartProduct
                name="Order Total"
                price={total}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/checkout/CheckoutCartSummary.js